import {
  Info as Icon // TODO: select an icon
} from 'components/icons';

export const meta = {
  id: 'ProductsDetails',
  title: 'ProductsDetails',
  category: '',
  unique: false,
  icon: Icon,
  version: '1.0.0',
  description: `The crud for managing the current org products'`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 440,
    height: 410
  }
};
